import React from 'react'
import styled from 'styled-components'
import Layout from '../components/Layout'
import { device } from '../components/Breakpoints'
import Image from '../img/404.jpg'
import ImageMobile from '../img/404-mobile.png'

const Container = styled.div`
  .desktop {
    display: block;
    @media ${device.mobileL} {
      display: none;
    }
  }
  .mobile {
    display: none;
    @media ${device.mobileL} {
      display: block;
    }
  }
`

const NotFoundPage = () => (
  <Layout>
    <Container>
      <img src={Image} alt="Página não encontrada" className="desktop" />
      <img src={ImageMobile} alt="Página não encontrada" className="mobile" />
    </Container>
  </Layout>
)

export default NotFoundPage
